import {Frame} from "../Components/Shared/Frame";
import PostCont from "../Components/Post/PostCont";

export const Post = () => {
  // console.log("Post")
    return(
    <>
      <Frame><PostCont /></Frame>
      </>
      )

    };